import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Alert } from 'assets/icons/Alert.svg';
import useToast from 'contexts/ToastProvider/useToast';

const useRefreshPageToast = () => {
  const { t } = useTranslation();
  const { pushToast } = useToast();

  const displayToast = useCallback(
    () =>
      pushToast({
        autoDismiss: false,
        title: t('errors.something_went_wrong'),
        variant: 'error',
        icon: Alert,
        actionText: t('refresh_page'),
        onAction: window.location.reload.bind(window.location),
        actionButtonVariant: 'textWhiteUnderline',
      }),
    [pushToast, t]
  );

  return displayToast;
};

export default useRefreshPageToast;
